export default __webpack_public_path__ + "static/media/V124_B_BD.0fabbb3a.pdf";